import styled from '@emotion/styled';
import React from 'react';
import { createPortal } from 'react-dom';

import CrossIcon from '@/assets/CrossIcon.svg';
import QRCodeIcon from '@/assets/QRCodeIcon.svg';

const Button = styled.button`
  position: fixed;
  top: 0.95rem;
  left: 1.5rem;
  z-index: 1000;
  background-color: transparent;
  border: none;
  width: 1rem;
  height: 1rem;
  padding: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const QRCodeButton: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ open, setOpen }) => {
  const icon = open ? CrossIcon : QRCodeIcon;
  const iconAriaLabel = open ? '關閉 QRCode' : '開啟 QRCode';
  const portal = document.querySelector('body');
  return portal
    ? createPortal(
        <Button onClick={() => setOpen((prev) => !prev)}>
          <img src={icon} alt={iconAriaLabel} />
        </Button>,
        portal
      )
    : null;
};

export default QRCodeButton;
